module.exports = __webpack_public_path__ + "media/components/mindfulness/breathing/bubbles-small-b230fe9bab1d9338bcf0479069384322.svg";